// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2jAbu","right":"styles_right__3yxCF"};